import { ShieldCheck, FileText, SearchCheck, Globe2, Scale, Lock } from "lucide-react";
import { FadeUp, Overline } from "@/components/Reveal";

const CARDS = [
  { icon: ShieldCheck, title: "Authenticity", text: "Products sourced through established professional supply channels." },
  { icon: FileText, title: "Documentation", text: "Commercial documentation available subject to transaction requirements." },
  { icon: SearchCheck, title: "Inspection", text: "Third-party inspection can be accommodated where commercially appropriate." },
  { icon: Globe2, title: "International Logistics", text: "Cross-border procurement and delivery structures." },
  { icon: Scale, title: "Commercial Compliance", text: "Transactions subject to relevant trade, export and destination requirements." },
  { icon: Lock, title: "Secure Transactions", text: "Commercial structures designed around the scale and requirements of the transaction." },
];

export const Confidence = () => (
  <section className="relative py-16 lg:py-24 bg-white" data-testid="confidence-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <FadeUp>
        <Overline>Trust &amp; Compliance</Overline>
        <h2 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-midnight">
          Supply with confidence.
        </h2>
        <p className="text-midnight/55 text-lg mt-6 max-w-3xl leading-relaxed">
          Royal Deals FZ-LLC sources products from leading global compute and technology manufacturers through professional international supply channels. Manufacturer-specific availability is provided directly against qualified enquiries.
        </p>
      </FadeUp>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {CARDS.map((c, i) => (
          <FadeUp key={c.title} delay={i * 0.07}>
            <div className="bg-white hairline p-9 h-full group hover:border-gold/40 hover:shadow-medium transition-[border-color,box-shadow] duration-300" data-testid={`confidence-card-${c.title.toLowerCase().replace(/\s+/g, "-")}`}>
              <c.icon size={24} className="text-gold" strokeWidth={1.5} />
              <p className="font-heading font-medium text-midnight mt-6 mb-3">{c.title}</p>
              <p className="text-sm text-midnight/55 leading-relaxed">{c.text}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
